import * as configs from './configs';
import getEmployeeStateTransitionPresets from './configs/trust/getEmployeeStateTransitionPresets';

const envs = {
  default: {
    API: '/api/',
    API_BASE: '', // Full API base URL for redirects (empty = same origin)
    HLR: true,
    ERROR_REPORTING: true,
    TITLE: 'Aspire ATS',
    NAVIGATION_CLASS: 'bg-dark',
    APPLICANT_SUMMARY_FIELDS: ['location', 'email', 'mobile', 'tel2', 'birth_date', 'public_transport_card', 'number_of_workdays'],
    APPLICANT_STATES: {
      New: 'Nieuw',
      'M&G planned': 'M&G gepland',
      'M&G canceled': 'M&G geannuleerd',
      'Trial planned': 'Training gepland',
      'Trial canceled': 'Training geannuleerd',
      Exit: 'Exit'
    },
    EMPLOYEE_STATES: {
      Active: 'Actief',
      Pause: 'Pauze',
      FormerEmployee: 'Oud-medewerker'
    },
    NOTIFICATION_LABELS: {
      'trial.confirmation': 'Training bevestiging',
      'mg.confirmation': 'M&G bevestiging',
      'mg.reminder': 'M&G herinnering',
      'trial.second_reminder': 'Training 2de herinnering',
      'trial.reminder': 'Training herinnering',
      'apply_confirmation': 'Welkomstmail',
      no_answer: 'Geen antwoord',
      no_show: 'Niet op komen dagen',
      'no_answer.email': 'Geen antwoord',
      'no_vacancies.email': 'Geen vacatures beschikbaar',
      'non_eu.email': 'Non-EU',
    },
    EMPLOYEE_STATE_TRANSITION_PRESETS: getEmployeeStateTransitionPresets,
  },
  'donniebase-goingabroad-d7o45ih27a-ez.a.run.app': configs.goingabroad,
  'donniebase-goingabroad-etfgaan4vq-ez.a.run.app': configs.goingabroad,
  'donniebase-goingabroad.tapraise.dev': configs.goingabroad,
  'donniebase-goingabroad.tapraise.app': configs.goingabroad,
  localhost: {
    ERROR_REPORTING: false,
    REDUX_CONSOLE: true,
    API_BASE: 'http://localhost:8080', // Backend runs on different port in dev
    ...configs.goingabroad,
  },
  'donniebase.nl': {
    HOSTED_DOMAIN: 'credo-marketing.nl',
    TITLE: 'Credo Fundraising',
    ...configs.trust,
  },
  'base.werkenbijthesalescompany.nl': {
    TITLE: 'The Sales Company',
    ...configs.trust,
  },
  'base.werkenbijtrustmarketing.nl': {
    TITLE: 'Trust Marketing',
    ...configs.trust,
  },
  'base.herohive.de': configs.herohive,
  'donniebase-herohive.tapraise.app': configs.herohive,
  'donniebase-trustes.tapraise.app': configs.trustes,
  'base.trustmarketing.es': configs.trustes,
};

export const getEnvironment = (hostname, log = false) => {
  const environment = { ...envs.default, ...envs[hostname] };
  if (log) {
    console.log(environment);
  }
  window.document.title = environment.TITLE;
  return environment;
};

export default getEnvironment(window.location.hostname, true);
